export default __webpack_public_path__ + "static/BestLawfirm2023-9cb402283cc38b672d2c14fee4815ef8.png";